import { IconCopy, IconWebhook, IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import IconButton from '../../../components/Buttons/IconButton';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';

const WebHookModal = () => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [webHookData, setWebHookData] = useState(null);

    const getData = async () => {
        loadingShow();
        let resp = await getApi(urlApi.getWebhookData);
        loadingHide();
        if (resp.responseCode === 200) {
            setWebHookData(resp.data);
            handleShow();
        } else {
            toast.error(resp.message);
            setWebHookData(null);
        }
    }

    function onCopy(copyText) {
        navigator.clipboard
            .writeText(copyText)
            .then(() => {
                toast.success("Webhook URL copied");
            })
            .catch(() => {
                toast.error("something went wrong");
            });
    }
    return (
        <>
            <button className='max-w-max text-xs bg-sky-300 shadow-sm !px-2 !py-0.5 text-gray-800 rounded-md font-semibold flex items-center !gap-0.5' onClick={getData}> <IconWebhook size={16} /> Webhook</button>
            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Webhook URL of your app.</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className="flex gap-3 py-10">
                        <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" value={webHookData} readOnly />
                        <IconButton icon={<IconCopy />} onClickFunction={() => onCopy(webHookData)} />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default WebHookModal